import styles from "./index.module.css";
import React from "react";
import classNames from "classnames";

export default function ({ className, ...props }) {
  return (
    <input
      type="radio"
      className={classNames(styles.radio, className)}
      disabled={props.readOnly}
      {...props}
    />
  );
}
